import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const ComplaintsService = {
  getComplaints: async (data) => {
    const response = await authInstance
      .get(`${url}/opsComplaints/list/?` + new URLSearchParams(data))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  createComplaint: async (data) => {
    const response = await authInstance
      .post(`${url}/opsComplaints/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },

  editComplaint: async (id, data) => {
    const response = await authInstance
      .put(`${url}/opsComplaints/${id}/update/`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
